const GamesController = () => import('./Controller')

export default function installComponents(Vue) {
  Vue.component('GamesController', GamesController)
}
